export default {
  title: {
    it: 'Network error'
  },

  text: {
    it: 'Please check your internet connection.'
  },

  button: {
    it: 'Done'
  }
};
